export default {
    transactions_details_title: 'Detalles de transacciones',
    transactions_details_created: 'Creado',
    transactions_details_transaction: 'Transacción Id',
    transactions_details_status: 'Estado',
    transactions_details_type: 'Tipo',
    transactions_details_message: 'Mensaje',
    transactions_details_data: 'Datos',
    transactions_details_created_by: 'Creado Por',
    transactions_details_duplicated_device: "Dispositivo Duplicado",
    transactions_details_processed: "Procesado",
    transactions_details_failure: "Error",
    transactions_details_pending: "Pendiente",
    transactions_details_in_progress:"En Progreso",
    transactions_details_void:"Vacio",
    transactions_details_unsubscribed:"Subscripción Cancelada",
    transactions_details_delivered:"Entregado",
    transactions_details_show_data: 'Mostrar Datos',
    transactions_details_unit: 'Unidad',
    transactions_details_details: 'Detalles',
    transactions_details_esn: 'ESN',
    transactions_details_hardwareVersion: 'Versión de Hardware',
    transactions_details_to: 'Para',

    transactions_details_type_units: 'Unidad',
    transactions_details_type_assets: 'Activo',
    transactions_details_type_subUsers: 'Subusuario',
    transactions_details_type_drivers: 'Conductor',
    transactions_details_name: 'Nombre',
    transactions_details_type_assetSubtypes: 'Subtipo de activo',
    transactions_details_type_account: 'Cuenta',

    transactions_details_units: 'Unidades',
    transactions_details_status_changed: 'Estado cambiado a',
};